<template>
    <div class="adyen-modal-loader">
        <CompassSkeleton size="large" />
        <CompassSkeleton size="x-large" :lines="2" />
        <CompassSkeleton size="medium" />
        <div v-for="index in 6" :key="index" class="adyen-modal-loader__field">
            <CompassSkeleton size="medium" />
            <CompassSkeleton size="x-large" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.adyen-modal-loader {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2);

    &__field {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-1);
    }
}
</style>
